<script setup lang="ts">
    import type { TrainingsListingItem } from '~/types/academy/baseTraining';
    import AcademyTrainingsCarouselCarousel from './AcademyTrainingsCarouselCarousel.vue';

    const { isInitialLoading, prettyError, items, showNoResults, noResultsMessage } = defineProps<{
        isInitialLoading: boolean;
        prettyError: string | null;
        items: TrainingsListingItem[];
        showNoResults: boolean;
        noResultsMessage: string;
    }>();
</script>

<template>
    <ClientOnly>
        <div
            v-if="isInitialLoading"
            class="skeleton-row"
        >
            <TeaserCardSkeleton
                v-for="i in 3"
                :key="i"
            />
        </div>

        <pre
            v-else-if="prettyError"
            class="error-message"
        >
            {{ prettyError }}
        </pre>

        <AcademyTrainingsCarouselCarousel
            v-else-if="items.length"
            :items="items"
        />

        <div
            v-else-if="showNoResults"
            class="no-results"
        >
            <Icon
                name="lucide:sparkles"
                size="48px"
                style="color: var(--brand-primary-70)"
            />
            <p>{{ noResultsMessage }}</p>
        </div>

        <template #fallback>
            <div class="skeleton-row">
                <TeaserCardSkeleton
                    v-for="i in 3"
                    :key="i"
                />
            </div>
        </template>
    </ClientOnly>
</template>

<style lang="scss" scoped>
    .skeleton-row {
        display: flex;
        gap: var(--spacing);
        overflow: hidden;
    }

    .no-results {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: var(--spacing);
        padding: var(--spacing--4) var(--spacing--2);
        border-radius: var(--border-radius);
        background-color: var(--brand-primary-10);
        text-align: center;

        p {
            max-width: 40rem;
            margin: 0;
        }
    }

    .error-message {
        margin: 0;
        padding: var(--spacing);
        border-radius: var(--border-radius-s);
        font-size: var(--font-xs);
        white-space: pre-wrap;
        word-break: break-word;
        background-color: var(--white);
        border: 1px solid var(--error);
        color: var(--error);
    }
</style>

